import { useState } from 'react';

/**
 * Boton que intenta usar Web Share API y cae a copiar al portapapeles.
 */
export default function ShareButton({ title, url, className = '', children = 'Compartir' }) {
  const [copied, setCopied] = useState(false);

  async function onClick(e) {
    e.preventDefault();
    e.stopPropagation();
    const fullUrl = new URL(url, window.location.origin).toString();

    if (navigator.share) {
      try {
        await navigator.share({ title, url: fullUrl });
        return;
      } catch {
        // si el usuario cancela navigator.share o falla, hacemos fallback
      }
    }
    try {
      await navigator.clipboard.writeText(fullUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch {
      prompt('Copia este enlace:', fullUrl);
    }
  }

  return (
    <button type="button" onClick={onClick} className={className}>
      {copied ? '✓ Copiado' : children}
    </button>
  );
}
